<template>
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Edukanji - login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form v-model="valid" @keyup.native.enter="login" >
                  <v-text-field
                    label="Login"
                    name="username"
                    v-model="username"
                    prepend-icon="person"
                    type="text"
                    :rules="rules"
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="pass"
                    v-model="pass"
                    prepend-icon="lock"
                    type="password"
                    :rules="rules"
                  ></v-text-field>
                </v-form>
                <v-alert type="error" dismissible v-if="error"  dense>{{error}}</v-alert>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
</template>

<script>
import Api from "@/services/Api";
import axios from "axios";

export default {
  name:'loginTemplate',
  data() {
    return {
      valid:false,
      error:"",
      username:"",
      pass:"",
      rules: [
        value => !!value || 'Required.',
        value => (value || '').length <= 20 || 'Max 20 characters',
      ]
    }
  },
  methods:{
    setAsValid(val) {
      this.valid = val;
    },
    login() {
      try {
          Api()
          .post("/api/cms/login",{username:this.username,pass:this.pass})
          .then((result) => {
            if(result.data) {
              this.$store.commit("setLoggedId",result.data.username);
              this.$router.push({path:"/cms"});
            }
          }).catch((error)=> {
            this.error = error.response.data;
            setTimeout(()=>{this.error = ""},6000)

          }) 
      } catch(err) {
        console.log(err);
      }
    }

  }
};
</script>